import React from 'react'

export default class Http {
	static get def() {
		return { value: '', label: '(' + trans.get('attrs/not_defined') + ')' };
	}

	static open(url, params, then) {
		let el_parent = null;
		let el_overlay = null;
		const onerror = (e) => {
			if (el_overlay && el_parent && el_parent.contains(el_overlay)) {
				el_parent.removeChild(el_overlay);
			}
			alert('Não foi possível efetuar este pedido. Poderá ter perdido a ligação. Tente mais tarde.');
		}

		if (params instanceof Function) {
			var aux = then;
			then = params;
			params = aux || {};
		}
		else if (params == undefined) {
			params = {};
		}
		const type = params.type || 'get';
		//var sync = params.sync || false;
		const req = new XMLHttpRequest();
		// se url é relativo e nao tem /
		if (!url.match(/^[a-z]+:\/\/|^\//i)) {
			url = '/' + url;
		}
		req.onload = () => {
			if (el_overlay && el_parent && el_parent.contains(el_overlay)) {
				el_parent.removeChild(el_overlay);
			}
			if (req.readyState != 4 || req.status != 200) {
				httpNotifier.unregister();
				//console.error(req);
				mbox.error(req.responseURL, req.statusText);
				if (params.error) {
					params.error(req);
				}
				return;
			}
			let response = null;

			try {
				response = req.response ? JSON.parse(req.response) : {};
			}
			catch(e) {
				const showResponse = () => {
					mbox.modal(<div dangerouslySetInnerHTML={{__html: req.response}} />, {
						title: __('attrs_reply')
					});
				};
				if (hp.store.env === 'dev') {
					console.log(req.response);
					showResponse();
				}
				else {
					mbox.show(__('errors_unknown_io_error'), __('errors_notice'), 'exclamation', [
						{
							type: 'primary',
							text: __('errors_response'),
							icon: 'exclamation',
							onClick: showResponse
						},
						'close'
					]);
				}
				return;
			}
			if (response.xupdte) { // se aplicacao em atualizacao
				window.location.reload();
				return;
			}
			else if (response.xpired) {
				//session.logout();
				httpNotifier.unregister();
				messages.register(response.messages);
				//Router.go('/login/index', true);
				return;
			}
			/*else {
				session.touch();
			}
			if (session.isActive()) {
				messages.clear(false);
			}*/
			if (response.msg || response.war || response.err || response.inf) {
				const msgs =
					[].concat(
						(response.msg || []).map(m => ({ msg: m, type: 'success' })),
						(response.inf || []).map(m => ({ msg: m, type: 'info' })),
						(response.war || []).map(m => ({ msg: m, type: 'warning' })),
						(response.err || []).map(m => ({ msg: m, type: 'danger' }))
					);
				let has_only_success_msg = response.success != false;
				if (response.success == undefined) {
					response.success = true;
					for (let msg of msgs) {
						if (!msg.type) {
							continue;
						}
						if (msg.type == 'danger' || msg.type == 'warning') {
							response.success = false;
							has_only_success_msg = false;
							break;
						}
						else if (msg.type == 'info') {
							has_only_success_msg = false;
						}
					}
				}
				if (has_only_success_msg) {
					messages.raiseEvents();
					notifications.set(msgs);
				}
				else {
					messages.set(msgs);
				}
				delete response.msg;
				delete response.war;
				delete response.err;
			}
			if (response.store) {
				Object.assign(hp.store, response.store);
				delete response.store;
			}
			/*
			if (response.debug) {
				let dbg = response.debug;

				delete response.debug;
				// nao se pode atribuir logo debug.set porque podemos estar num render
				// e isso poderia causar outro render do Debug
				setTimeout(() => { debug.set(url, dbg); }, 0);
			}
			*/
			let success = response.success || response.success == undefined;
			delete response.success;

			if (params.def && Array.isArray(response)) {
				response.unshift(typeof params.def == 'object' ? params.def : Http.def);
			}
			if (then) {
				then(response, success);
			}
			httpNotifier.unregister();
		}
		req.onerror = onerror

		let data = params.data || null;
		let content_type = null;

		if (params.data) {
			if (type == 'get') {
				url += (url.indexOf('?') < 0 ? '?' : '&') + Object.toParam(params.data);
				content_type = 'application/x-www-form-urlencoded';
			}
			else if (!(data instanceof FormData)) {
				content_type = 'application/x-www-form-urlencoded';
				data = 'json=' + encodeURIComponent(JSON.stringify(params.data));
			}
		}
		if (!params.silent) {
			const el_loading = document.createElement('div');

			el_loading.setAttribute('class', 'loading');
			//el_loading.setAttribute('style', 'height: 100%');
			el_loading.appendChild(document.createElement('div'));

			// mostra o loader durante o processamento
			el_overlay = document.createElement('div');
			el_overlay.setAttribute('class', 'ui-widget-overlay http-overlay');
			el_overlay.appendChild(el_loading);
			el_parent = document.getElementById('loader') || document.body;
			el_parent.appendChild(el_overlay);
		}
		else {
			delete params.silent;
		}
		req.open(type, url, params.async === undefined ? true : params.async);
		if (content_type) {
			req.setRequestHeader('Content-Type', content_type);
		}
		req.setRequestHeader('HTTP_X_REQUESTED_WITH', 'xmlhttprequest');
		req.send(data);
		httpNotifier.register();
	}

	static get(url, params, then) {
		if (params == undefined) {
			params = {};
		}
		else if (params && !params.data) {
			params = { data: params };
			['dataType', 'async', 'type', 'silent'].forEach(def => {
				if (params.data[def] !== undefined) {
					params[def] = params.data[def];
					delete params.data[def];
				}
			});
		}
		params.type = 'get';
		Http.open(url, params, then);
	}

	static post(url, params, then) {
		if (params == undefined) {
			params = {};
		}
		else if (params && !params.data) {
			params = { data: params };
			['dataType', 'async', 'type', 'silent'].forEach(def => {
				if (params.data[def] !== undefined) {
					params[def] = params.data[def];
					delete params.data[def];
				}
			});
		}
		params.type = 'post';
		Http.open(url, params, then);
	}
}
